import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {updateBrandName} from "../../../services/api/apiBrands";

class EditBrandsPopup extends Component {
    constructor(props) {
        super(props);
        this.state={
            brandName: '',
            store: '',
            isUpdating: false,
            error: ''
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen !== prevProps.isOpen) {
            this.setState({
                brandName: this.props.brandName,
                store: this.props.store,
                error: ''
            })
        }
    }

    // _handleChangeInput = (e) => {
    //     const {value} = e.target;
    //
    //     if(value.length < 51){
    //         this.setState({
    //             error: ''
    //         });
    //     }else{
    //         this.setState({
    //             error: 'Số ký tự của brand name nhỏ hơn hoặc bằng 50.'
    //         });
    //     }
    //
    //     this.setState({
    //         brandName: value
    //     });
    // }

    _handleChangeInput = (field) => e => {
        const {value} = e.target;
        if(field === 'brandName'){
            if(value.length < 51){
                this.setState({
                    error: ''
                });
            }else{
                this.setState({
                    error: 'Số ký tự của brand name nhỏ hơn hoặc bằng 50.'
                });
            }
        }

        this.setState({
            [field]: value
        });
    }

    _isDisable = () => {
        const {store, brandName} = this.state
        if(store !== '' && brandName !== '' && brandName.length < 51){
            return false
        }else{
            return true
        }
    }

    _handleClickSaveEditBrand = () => {
        const {store, brandName} = this.state

        this.setState({
            isUpdating: true,
            error: ''
        })

        const payload = {
            store,
            name: brandName,
        }

        updateBrandName(this.props.brandId,payload)
            .then(result => {
                if(result.success){
                    this.setState({
                        brandName: '',
                        isUpdating: false,
                        error: ''
                    })
                    this.props.onTogglePopup()
                    this.props.reLoadBrandsList()
                }else{
                    this.setState({
                        isUpdating: false,
                        error: result.message
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        const {isOpen, onTogglePopup} = this.props
        const {error, store, brandName} = this.state
        const isDisable = this._isDisable();

        return(
            <Modal isOpen={isOpen} toggle={onTogglePopup} className="add-brand-popup">
                <ModalHeader toggle={onTogglePopup}>Edit brand</ModalHeader>
                <ModalBody>
                    <div className="form-input">
                        <label className="font-weight-bold">Store <span>*</span></label>
                        <div className="box-input">
                            <input className="form-control" name="store" value={store} placeholder="Input namespace" onChange={this._handleChangeInput('store')}/>
                        </div>
                    </div>

                    <div className="form-input">
                        <label className="font-weight-bold">Brand name <span>*</span></label>
                        <div className="box-input">
                            <input className="form-control" name="brandName" value={brandName} placeholder="Input brand name" onChange={this._handleChangeInput('brandName')}/>
                            <span className="input-note">
                                {error ? error : ''}
                            </span>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <button className="btn btn-secondary" color="secondary" onClick={onTogglePopup}>cancel
                    </button>
                    <button onClick={this._handleClickSaveEditBrand} className="btn btn-primary" disabled={isDisable}>
                        Save
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default EditBrandsPopup
